<form [formGroup]="config">
  <ul class="template-section-config">
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="template-entity-type-wrapper config-field-container">
          <app-editable-mode-toggle
            [section]="section">
          </app-editable-mode-toggle>
        </div>
        <div class="template-entity-type-wrapper config-field-container">
          <mat-checkbox formControlName="required">
            Required
          </mat-checkbox>
        </div>
      </section>
    </li>
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="template-entity-type-wrapper config-field-container">
          <label>Template entity type</label>
          <app-entity-type-dropdown
            [entityType]="entityType"
            [formGroup]="config"
            [allowedEntityTypes]="allowedEntityTypes">
          </app-entity-type-dropdown>
        </div>
        @if (!shouldHideFileTypes) {
          <div class="template-entity-type-wrapper config-field-container">
            <label>File type</label>
            <app-document-type-dropdown
              [entityTypes]="dropdownEntityTypes"
              [control]="config.get('templateFileTypes')">
            </app-document-type-dropdown>
          </div>
        }
      </section>
    </li>
    <li class="config-row">
      <section class="basic-flex-container">
        <div class="template-entity-type-wrapper config-field-container">
          <app-default-template
            [section]="section"
            [entity]="entityType">
          </app-default-template>
        </div>
      </section>
    </li>
  </ul>
</form>
